export enum DisputeReason {
  BillingError = 'BILLING_ERROR',
  NotReceived = 'NOT_RECEIVED',
  NotAsDescribed = 'NOT_AS_DESCRIBED',
}
